import React from 'react';
import { Link } from 'react-router-dom';
import type { Post } from '../data/posts';

/** One dated row in a Signals list: date and category on the left, title on the right. */
export function PostRow({
  post,
  withExcerpt
}: {
  post: Post;
  withExcerpt?: boolean;
}) {
  return <Link className={`prow${withExcerpt ? '' : ' tight'}`} to={`/blog/${post.slug}`} data-id="element-319" data-mp="q7xvyyen597f">
      <div className="meta" data-id="element-320" data-mp="q639hfnq1918">
        <time className="dt" dateTime={post.date} data-id="element-321" data-mp="14waua217b453">
          {post.dateLabel.toUpperCase()}
        </time>
        <span className="ptag" data-id="element-322" data-mp="zyirue2xjzmn">{post.category.toUpperCase()}</span>
      </div>
      <div className="txt" data-id="element-323" data-mp="1dxij7thtusmi">
        <div className="t" data-id="element-324" data-mp="1dxs5b5zr4fmx">{post.title}</div>
        {withExcerpt && <div className="b" data-id="element-325" data-mp="19vx8oesrmqfh">{post.excerpt}</div>}
      </div>
    </Link>;
}